/** Round gross amount to nearest rupee for invoice total (not always up). */
export function calculateInvoiceRoundOff(grossAmt) {
  const gross = parseFloat(grossAmt) || 0;
  const invoiceAmt = Math.round(gross);
  const roundedOff = parseFloat((invoiceAmt - gross).toFixed(2));
  return {
    invoice_amt: invoiceAmt,
    rounded_off: roundedOff,
  };
}
